import React, { useEffect, useState } from 'react';
// import DOMPurify from 'dompurify';
import { post } from '../Auths/AuthToken';
import { useRef } from 'react';
import CounselingAccordion from './CounselingAccordion';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import CounselingSecColSubChildUnRegister from './CounselingSecColSubChildUnRegister';
import CounselingSecColSubChild from './CounselingSecColSubChild';
import SubTypePopup from './SubTypePopup';
import AddSubValPopup from './AddSubValPopup';
import setUiMessage from '../../Utilities/Tostify';
import CopyFromLastVisitDropDown from '../../Utilities/CopyFromLastVisitDropDown';
import { handleCounsellingFormMidItem } from '../../httpdata/appointmentsdata';
import SelectProblem from './SelectProblem';
import _ from 'lodash';
import Button from '../Button';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../redux/slices/appSlice';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { stripHtml } from '../../Utilities/Utilities';

function CounsellingPopup({
  handleClose,
  patientId,
  soapId,
  appId,
  visitId,
  handleReload,
  appGrpId = '',
  templateId,
}) {
  const [allData, setAllData] = useState(false);
  const [textAreaData, setTextAreaDataData] = useState({});
  const [checkBoxData, setCheckBoxData] = useState({});
  const [showHideChiled, setShowHideChiled] = useState('1_2');
  const [classFirstCol, setClassFirstCol] = useState('1_2');
  const [checkedAll, setCheckedAll] = useState({});
  const [childId, setChildId] = useState('');
  const [catAndId, setCatAndId] = useState('1_2');
  const [childSerch, setChildSerch] = useState({});
  const [ptcId, setPtcId] = useState('');
  const [accord, seAccord] = useState({});
  const [probIds, setProbIds] = useState('');

  const [intPatientId, setIntPatientId] = useState(patientId);
  const [intSoapId, setIntSoapId] = useState(soapId);
  const [intAppId, setIntAppId] = useState(appId);
  const [intVisitId, setIntVisitId] = useState(visitId);
  const [loading, setLoading] = useState(false);

  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [subTypePopup, setSubTypePopup] = useState(false);
  const [subChildPrams, setSubChildPrams] = useState([]);
  const [addSubChild, setAddSubChild] = useState(false);
  const [editSubChild, setEditSubChild] = useState({
    status: false,
    data: null,
  });
  const [lastVisitData, setLastVisitData] = useState('');
  //const [copyToAll, setCopyToAll] = useState('');
  const [count, setCount] = useState(0);
  const [diagKey, setDiagKey] = useState(0);
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);
  const scrollRefs = useRef([]);
  const checkboxRef = useRef([]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await post(
          'api/patient/progressNote/openTherapyPopup',
          {
            patientId: intPatientId,
            soapId: intSoapId,
            appId: intAppId,
            visitId: intVisitId,
            counsPatId: patientId,
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
          setLoading(false);
          setPtcId(response?.data?.ptcId);
          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `therapyDetailsText_${data[3]}_${subData[0]}`;
                // Sanitize subData[3] and store the cleaned string with newlines
                acc[key] = stripHtml(subData[3]);
                if (subData[1] === 'Diagnosis') setDiagKey(key);
              });
              return acc;
            },
            {},
          );

          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (subData[4] === 'dx' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.dxId}`;

                      acc[key] = false;
                    }
                  } else if (
                    subData[4] === 'focus' &&
                    response?.data?.golObjData
                  ) {
                    for (let f in response?.data?.golObjData) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.golObjData[f]?.goalId}`;

                      acc[key] = false;
                    }
                  } else {
                    subData[2] &&
                      subData[2]?.forEach((subChildData) => {
                        const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                        acc[key] =
                          subChildData?.is_checked === '1' ? true : false;
                      });
                  }
                });
              return acc;
            },
            {},
          );

          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [intPatientId, intSoapId, intAppId, intVisitId, globalReload, patientId]);

  const handleCounsellingFormSave = async (
    type,
    pramPtcId = '',
    pramPatientId = '',
    pramAppId = '',
    pramVisitId = '',
    pramSoapId = '',
    index = 0,
  ) => {
    try {
      if (appGrpId && appGrpId !== '0' && !probIds) {
        setUiMessage('err', 'Please select problem.');
        return;
      }
      const response = await post(
        'api/patient/progressNote/saveTherapyCounclForm',
        {
          patientId: intPatientId,
          soapId: intSoapId,
          appId: intAppId,
          visitId: intVisitId,
          staffUserId: user?.id,
          ptcProbId: probIds,
          copy: type === 'copy' ? 1 : '', //copy to all pateint while group counseling
          therapyDataJson: getTherapyJson(),
          counsPatId: patientId,
          tempid: templateId,
        },
      );
      if (response.status === 200) {
        dispatch(
          setRenderFormData({
            data: {
              genDetail: response.data.genDetail,
              renderTherapyData: response.data.renderTherapyData,
            },
            type: 'counselling',
          }),
        );
        dispatch(
          setRenderFormData({
            data: {
              genDetail: response.data.genDetail,
              renderTherapyData: response.data.renderTherapyData,
            },
            type: 'counselling',
          }),
        );
        if (appGrpId && appGrpId !== '0') {
          if (type === 'side') {
            setCount(index);
            handleReload('counselling');
          } else if (type === 'next') {
            if (count >= allData.groupCounsList.length - 1) {
              setCount(0);
            } else {
              setCount(count + 1);
            }
            handleReload('counselling');
          } else if (type === 'copy') {
            dispatch(handleGlobalReload(!globalReload));
            handleReload('counselling', '1');
          } else if (type === 'close') {
            handleClose();
            handleReload('counselling');
          }
        } else {
          handleClose();
          handleReload('counselling');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingFormUpdate = async (
    type,
    pramPtcId = '',
    pramPatientId = '',
    pramAppId = '',
    pramVisitId = '',
    pramSoapId = '',
    index = 0,
  ) => {
    try {
      if (appGrpId && appGrpId !== '0' && !probIds) {
        setUiMessage('err', 'Please select problem.');
        return;
      }
      const response = await post(
        'api/patient/progressNote/updateTherapyCouncilForm',
        {
          patientId: intPatientId,
          soapId: intSoapId,
          appId: intAppId,
          visitId: intVisitId,
          staffUserId: user?.id,
          ptcProbId: probIds,
          copy: type === 'copy' ? 1 : '', //copy to all pateint while group counseling
          ptcId: ptcId,
          therapyDataJson: getTherapyJson(),
          counsPatId: patientId,
          tempid: templateId,
        },
      );
      if (response.status === 200) {
        dispatch(
          setRenderFormData({
            data: {
              genDetail: response.data.genDetail,
              renderTherapyData: response.data.renderTherapyData,
            },
            type: 'counselling',
          }),
        );
        if (appGrpId && appGrpId !== '0') {
          if (type === 'side') {
            setCount(index);
            handleReload('counselling');
          } else if (type === 'next') {
            if (count >= allData.groupCounsList.length - 1) {
              setCount(0);
            } else {
              setCount(count + 1);
            }
            handleReload('counselling');
          } else if (type === 'copy') {
            dispatch(handleGlobalReload(!globalReload));
            handleReload('counselling', '1');
          } else if (type === 'close') {
            handleClose();
            handleReload('counselling');
          }
        } else {
          handleReload('counselling');
          handleClose();
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getTherapyJson = () => {
    let masterArr = [];
    let hisAndSymMaster = document.querySelectorAll('.therapyAddEditSection');
    let retStr = false;
    if (hisAndSymMaster) {
      hisAndSymMaster.forEach(function (element) {
        const masterId = element.getAttribute('value');
        // let masterText = document.querySelector(
        //   '#therapyDetailsText_' + masterId
        // ).value;
        let masterText = textAreaData['therapyDetailsText_' + masterId];

        let hisAndSymChield = document.querySelectorAll(
          '.ptcMasterSubChildData_' + masterId,
        );

        let childArr = [];
        hisAndSymChield.forEach(function (element, i) {
          let childIdTextArr = element.getAttribute('id').split('_');
          let subTypeVal = element.getAttribute('attr')
            ? element.getAttribute('attr')
            : '0';

          let childText = document.getElementById(
            'ptcSubChildDataList_' + masterId + '_' + childIdTextArr[3],
          ).textContent;

          childArr.push({
            masterId: masterId,
            childId: childIdTextArr[3],
            childText: childText.trim(),
            childInput: checkBoxData[element.getAttribute('id')] ? '1' : '0', //isChecked ? '1' : '0',
            childSubKey: subTypeVal,
          });
        });
        masterArr.push({
          masterId: masterId,
          masterText: masterText,
          childArr: childArr,
        });
      });
      retStr = JSON.stringify(masterArr);
    }
    return retStr;
  };

  const handleInputChange = (e) => {
    // const { id } = e.target;

    // const sanitizedContent = DOMPurify.sanitize(e.target.innerHTML);
    // setTextAreaDataData({ ...textAreaData, [id]: sanitizedContent });
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleSubTypePopup = (data) => {
    setSubTypePopup(true);
  };

  const handleCheckBoxLable = (eleId, data) => {
    if (data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([eleId, data]);
    } else {
      const target = checkboxRef.current[eleId];
      let checked = !target.checked;
      handleCheckBoxChangeComn(eleId, checked);
      setCheckBoxData({
        ...checkBoxData,
        [eleId]: checked ? true : false,
      });
    }
  };

  const handleCheckBoxChange = (e, data) => {
    const { id, checked } = e.target;
    if (checked && data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([e.target.id, data]);
      setCheckBoxData({
        ...checkBoxData,
        [e.target.id]: true,
      });
    } else {
      setCheckBoxData({
        ...checkBoxData,
        [id]: checked ? true : false,
      });
      handleCheckBoxChangeComn(id, checked);
    }
  };

  const handleCheckBoxChangeComn = (id, checked) => {
    const idArr = id?.split('_');

    let selStr = document?.querySelector(
      '#ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
    ).textContent;

    let resSelStr = document?.querySelector(
      '#ptcdiagReason_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
    ).textContent;

    if (resSelStr !== 'undefined') {
      selStr += resSelStr ? '\n' + resSelStr : '';
    }

    setChildId(idArr[1] + '_' + idArr[2]);
    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    if (checked) {
      textData = textData?.replace(selStr, '');

      textData = textData
        // .replace(/^<br\/>|<br\/>$/g, '')
        .replace(/^\n|\n$/g, '');

      textData = textData?.replace(/^,*\s*|,*\s*$/, '');

      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
          ? textData + '\n' + selStr
          : selStr,
      });
    } else {
      if (textData?.indexOf('\n' + selStr) === -1) {
        textData = textData?.replace(selStr + '\n', '');
      } else {
        textData = textData?.replace('\n' + selStr, '');
      }
      textData = textData?.replace(selStr, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');

      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData,
      });
    }
  };

  useEffect(() => {
    if (childId) {
      let allChecked = true;
      const newObj = {};
      // const spl = childId?.split('_');
      for (const key in checkBoxData) {
        if (key.startsWith('ptcSubChildDataListInpt_' + childId + '_')) {
          newObj[key] = checkBoxData[key];
        }
      }
      for (const i in newObj) {
        if (newObj[i] === false) {
          allChecked = false;
        }
      }

      Object.keys(newObj).length !== 0 &&
        setCheckedAll((prevState) => ({
          ...prevState,
          [childId]: allChecked,
        }));
    }
  }, [checkBoxData, childId]);

  const handleSubDataShow = (id) => {
    setShowHideChiled(id);
    setClassFirstCol(id);
    setCatAndId(id);
    setChildId(id);
    const allElements = document.querySelectorAll('.cnslng-actv-area');
    allElements.forEach((element) => {
      element.classList.remove('cnslng-actv-area');
    });
    const target = scrollRefs.current['therapyDetailsText_' + id];
    target.scrollIntoView({ behavior: 'smooth' });
    target.className = 'cnslng-actv-area';
  };

  const selectAll = (e, id) => {
    const { checked } = e.target;
    setCheckedAll({ ...checkedAll, [id]: checked ? true : false });

    let secColdata = document.querySelectorAll('.ptcMasterSubChildData_' + id);
    let finalText = '';
    secColdata.forEach(function (element, i) {
      let idArr = element.getAttribute('id').split('_');
      let selStr = document.getElementById(
        'ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
      ).textContent;

      if (checked) {
        checkBoxData[element.getAttribute('id')] = checked;
        finalText += selStr + '\n';
      } else {
        checkBoxData[element.getAttribute('id')] = checked;
      }
    });
    finalText = finalText.slice(0, -2);
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + id]: finalText,
    });
  };

  const handleChildSerch = (e, id) => {
    const { value } = e.target;
    setChildSerch({});
    setChildSerch({ ...childSerch, [id]: value });
  };

  useEffect(() => {
    let userInput = childSerch[catAndId]?.replace(/\\/g, '').toLowerCase();
    let secCol = document.querySelectorAll(
      '.ptcMasterSubChildData_' + catAndId,
    );
    secCol.forEach(function (element, i) {
      let searchTerm = element.getAttribute('data-search-term').toLowerCase();
      if (searchTerm.search(userInput) === -1) {
        element.classList.add('hide');
      } else {
        element.classList.remove('hide');
      }
    });
  }, [childSerch, catAndId]);

  const handleRemoveSubChild = (id) => {
    setRemoveSubChild(true);
    setSucPrams(id);
  };

  const handleEditSubChild = (id) => {
    setEditSubChild({ ...editSubChild, status: true, data: id });
  };

  const handleRemoveSubChildConfirm = async (id) => {
    const idArr = id.split('_');
    const itemId = idArr[2];
    if (itemId) {
      const responce = await handleCounsellingFormMidItem(itemId, 'ptc');
      if (responce?.status === 200) {
        if (responce.data.message === 'success') {
          setUiMessage('suc', 'Record deleted successfully.');
          setCheckBoxData({
            ...checkBoxData,
            ['ptcSubChildDataListInpt_' + id]: false,
          });
          const split = id?.split('_');
          const selStr = document?.querySelector(
            '#ptcSubChildDataList_' + id,
          ).innerHTML;

          setChildId(split[0] + '_' + split[1]);

          let textData =
            textAreaData['therapyDetailsText_' + split[0] + '_' + split[1]];

          if (textData?.indexOf('\n' + selStr) === -1) {
            textData = textData?.replace(selStr + '\n', '');
          } else {
            textData = textData?.replace('\n' + selStr, '');
          }

          //textData = textData?.replace(selStr, '');
          textData?.replace(/^,*\s*|,*\s*$/, '');
          setTextAreaDataData({
            ...textAreaData,
            ['therapyDetailsText_' + split[0] + '_' + split[1]]: textData,
          });

          const element = document.querySelector(
            '#ptcSubChildDataListInpt_' + id,
          );
          element.remove();
          setRemoveSubChild(false);
        }
      } else {
        setUiMessage('err', 'Something went wrong.');
      }
    }
  };

  const handlesubtypeform = (id, data) => {
    const idArr = id?.split('_');
    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    //if (checked) {
    textData = textData?.replace(data, '');
    textData = textData?.replace(/^,*\s*|,*\s*$/, '');
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
        ? textData + '\n' + data
        : data,
    });
    //}

    setCheckBoxData({
      ...checkBoxData,
      [id]: true,
    });
  };

  const handleCalbackData = (data, catagory, i, j, subTypeSection, mode) => {
    setCheckBoxData({
      ...checkBoxData,
      [`consultSubChildDataListInpt_${data[0]}_${data[1]}_${data[2]}`]: false,
    });

    const updatedData = [...allData?.therapyMasterData];
    if (mode === 'add') {
      const newObj = {
        child_id: data[2],
        child_texte: catagory,
        sub_type: subTypeSection ? '1' : '0',
      };
      updatedData[i][2][j][2].push(newObj);
    } else {
      const newObjIndex = updatedData[i][2][j][2].findIndex(
        (obj) => obj.child_id === data[2],
      );
      if (newObjIndex !== -1) {
        updatedData[i][2][j][2][newObjIndex].child_texte = catagory;
        updatedData[i][2][j][2][newObjIndex].sub_type = subTypeSection
          ? '1'
          : '0';
        // You can update other properties as well
      }
    }
    //setAllData(updatedData);
  };
  const prevGroupCounsList = useRef(null);
  useEffect(() => {
    const currentGroupCounsList = allData.groupCounsList; // Perform a deep comparison
    if (!_.isEqual(prevGroupCounsList.current, currentGroupCounsList)) {
      prevGroupCounsList.current = currentGroupCounsList; // Update the ref with the current value
    }
    if (currentGroupCounsList && currentGroupCounsList[count]) {
      const {
        ptcId = null,
        patientId = null,
        soapId = null,
        appId = null,
        visitId = null,
      } = allData.groupCounsList[count];
      setPtcId(ptcId);
      setIntPatientId(patientId);
      setIntSoapId(soapId);
      setIntAppId(appId);
      setIntVisitId(visitId);
    }
    //}
  }, [count, allData.groupCounsList]);

  const handleReStoreLastVisitData = (data) => {
    setLastVisitData(data);
    let args = data.split('_');
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openTherapyPopup',
          {
            patientId: intPatientId,
            appId: args[1],
            visitId: args[2],
            soapId: args[0],
          },
        );
        if (response.status === 200) {
          setAllData((lastData) => ({
            ...lastData,
            lastVisArr: response?.data?.lastVisArr,
            //probArr: response?.data?.probArr,
            soapDetail: response?.data?.soapDetail,
            therapyMasterData: response?.data?.therapyMasterData,
          }));

          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `therapyDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = stripHtml(subData[3]) || '';
              });
              return acc;
            },
            {},
          );
          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (subData[4] === 'dx' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.dxId}`;

                      acc[key] = false;
                    }
                  } else if (
                    subData[4] === 'focus' &&
                    response?.data?.golObjData
                  ) {
                    for (let f in response?.data?.golObjData) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.golObjData[f]?.goalId}`;

                      acc[key] = false;
                    }
                  } else {
                    subData[2] &&
                      subData[2]?.forEach((subChildData) => {
                        const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                        acc[key] =
                          subChildData?.is_checked === '1' ? true : false;
                      });
                  }
                });
              return acc;
            },
            {},
          );

          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleAllWnl = (e, id) => {
    (async () => {
      try {
        const response = await post('api/patient/ProgressNote/getAllWNLData', {
          id: id[0],
        });
        if (response.status === 200) {
          let chkBoxData = {};
          let textAreaData = {};
          if (response?.data.length > 0) {
            response?.data.forEach((data, i) => {
              data.forEach((item, i) => {
                let eleId = `ptcSubChildDataListInpt_${item?.catagory}_${item?.child}_${item?.subChild}`;
                const textAreaId = `therapyDetailsText_${item?.catagory}_${item?.child}`;
                chkBoxData[eleId] = e.target.checked;
                textAreaData[textAreaId] = e.target.checked
                  ? 'Within normal limits'
                  : '';
              });
            });
          }
          setCheckBoxData((prev) => {
            return { ...prev, ...chkBoxData };
          });
          setTextAreaDataData((prev) => {
            return { ...prev, ...textAreaData };
          });
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleproblems = (data) => {
    setProbIds(data);
  };

  const copyToAllPat = () => {
    if (ptcId) {
      handleCounsellingFormUpdate('copy', 1);
    } else {
      handleCounsellingFormSave('copy', 1);
    }
  };

  const handlepaPCounsellingForm = (
    ptcId,
    patientId,
    appId,
    visitId,
    soapId,
    index,
  ) => {
    if (ptcId) {
      handleCounsellingFormUpdate(
        'side',
        ptcId,
        patientId,
        appId,
        visitId,
        soapId,
        index,
      );
    } else {
      handleCounsellingFormSave(
        'side',
        ptcId,
        patientId,
        appId,
        visitId,
        soapId,
        index,
      );
    }
  };

  const handleCloseFun = (type) => {
    if (type === 'silent') {
      handleClose();
      return;
    }
    if (appGrpId && appGrpId === '0') {
      if (allData?.mode === 'add') {
        handleCounsellingFormSave();
      } else if (allData?.mode === 'update') {
        handleCounsellingFormUpdate();
      }
    } else {
      if (ptcId) {
        handleCounsellingFormUpdate('close');
      } else {
        handleCounsellingFormSave('close');
      }
    }
  };

  const hadleProblemText = (data, type) => {
    let textData = textAreaData[diagKey];

    if (type === 'add') {
      textData = textData?.replace(data, '');
      textData = textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        [diagKey]: textData ? textData + '\n' + data : data,
      });
    } else {
      if (textData?.indexOf('\n' + data) === -1) {
        textData = textData?.replace(data + '\n', '');
      } else {
        textData = textData?.replace('\n' + data, '');
      }
      textData = textData?.replace(data, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');

      setTextAreaDataData({
        ...textAreaData,
        [diagKey]: textData,
      });
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr mat-cnslng-fu-con center-popup">
        {loading && (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: '#ccc',
              position: 'absolute',
              opacity: '.5',
              zIndex: '10000',
              display: ' flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: '18px' }}>Loading...</span>
          </div>
        )}
        <div
          className="main-contnr-hdr flex-sec"
          style={{ alignItems: 'center', padding: '5px 10px' }}
        >
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">
              {appGrpId && appGrpId !== '0'
                ? 'Group counseling:'
                : 'Counseling:'}
            </span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div className="hdr-pt-info" style={{ width: '24%' }}>
            {appGrpId && appGrpId !== '0' ? (
              ''
            ) : (
              <CopyFromLastVisitDropDown
                dataArr={allData}
                selectedVal={lastVisitData}
                calback={(selectedOption) =>
                  handleReStoreLastVisitData(selectedOption?.value)
                }
              />
            )}
          </div>

          <Button variant="circle" onClick={handleCloseFun}>
            X
          </Button>
        </div>

        <div
          className={`${
            appGrpId && appGrpId !== '0'
              ? 'main-contnr-bdy mat-cnslng-fu-bdy flex-sec gc-cnslng'
              : 'main-contnr-bdy mat-cnslng-fu-bdy flex-sec'
          }`}
        >
          {appGrpId && appGrpId !== '0' && allData?.groupCounsList && (
            <div className="mat-cnslng-col0">
              {allData?.groupCounsList.map((item, i) => (
                <div
                  key={i}
                  className={`${
                    item?.patientId === intPatientId ? 'prgrs-actv left' : ''
                  } grp-couns prgrs-scrn-tab left`}
                  onClick={() =>
                    handlepaPCounsellingForm(
                      item?.ptcId,
                      item?.patientId,
                      item?.appId,
                      item?.visitId,
                      item?.soapId,
                      i,
                    )
                  }
                >
                  <span
                    className="done-check"
                    dangerouslySetInnerHTML={{
                      __html: item?.stLabel,
                    }}
                  />
                  <span
                    className="normal left qwidth100 fontsize14"
                    style={{ width: '80%' }}
                  >
                    {item?.patientFullName}
                  </span>
                  <span className="left med-label width100 fontsize12">
                    Chart#: {item?.gender} | {item?.age} [{item?.gender}]
                  </span>
                  <span className="left med-label width100 fontsize12">
                    DOB: {item?.dob}
                  </span>
                </div>
              ))}
            </div>
          )}
          <div>
            {appGrpId && appGrpId !== '0' && allData?.groupCounsList && (
              <div className="">
                <div
                  className="asmnt-prnt-blk-ftr"
                  style={{ width: '38%', float: 'right' }}
                >
                  <span
                    className="actn-yes right clear-right width-unset"
                    onClick={copyToAllPat}
                  >
                    Copy to all patients
                  </span>

                  {allData?.groupCounsList.length > 1 ? (
                    <>
                      {ptcId ? (
                        <span
                          className="actn-yes right clear-right clear-left width-unset"
                          onClick={() => handleCounsellingFormUpdate('next')}
                        >
                          Save &amp; Next
                        </span>
                      ) : (
                        <span
                          className="actn-yes right clear-right clear-left width-unset"
                          onClick={() => handleCounsellingFormSave('next')}
                        >
                          Save &amp; Next
                        </span>
                      )}
                    </>
                  ) : (
                    <>
                      {ptcId ? (
                        <span
                          className="actn-yes right clear-right clear-left width-unset"
                          onClick={handleCounsellingFormUpdate}
                        >
                          Save
                        </span>
                      ) : (
                        <span
                          className="actn-yes right clear-right clear-left width-unset"
                          onClick={handleCounsellingFormSave}
                        >
                          Save
                        </span>
                      )}
                    </>
                  )}
                  <span
                    className="actn-No right clear-right width-unset"
                    style={{ marginTop: '10px', clear: 'both' }}
                    onClick={handleCloseFun}
                  >
                    Close
                  </span>
                </div>
                <SelectProblem
                  key={allData?.prefProbList && allData?.patActProbList.length}
                  rendercommonFormData={allData?.problemList || []}
                  patActProbList={allData?.patActProbList}
                  prefProbList={allData?.prefProbList}
                  callBack={handleproblems}
                  hadleProblemText={(data, type) =>
                    hadleProblemText(data, type)
                  }
                  horizontol={true}
                />
              </div>
            )}
            <div className="main-contnr-bdy mat-cnslng-fu-bdy flex-sec">
              <div className="mat-cnslng-col1">
                {allData?.therapyMasterData?.map((data, r) => (
                  <CounselingAccordion
                    key={r}
                    classFirstCol={classFirstCol}
                    accord={accord}
                    handleSubDataShow={handleSubDataShow}
                    parent={data}
                    handleClick={(id) => {
                      seAccord(data[3]);
                      handleSubDataShow(data[3] + '_' + data[2][0][0]);
                    }}
                    moduleName={'therapyAddEditSection'}
                    handleAllWnl={handleAllWnl}
                    popupName={'follow-up-counseling'}
                  />
                ))}
              </div>
              <div className="mat-cnslng-col2">
                {allData?.therapyMasterData?.map((data, i) => (
                  <div key={i}>
                    {data[2] &&
                      data[2]?.map((subData, j) => (
                        <div
                          key={j}
                          id={'ptcSubChildBox_' + data[3] + '_' + subData[0]}
                          className={
                            showHideChiled === data[3] + '_' + subData[0]
                              ? ''
                              : 'hide'
                          }
                          style={{ height: '100%' }}
                        >
                          <div className="sec-col-serch">
                            <span className="clear5 clear-left10">
                              <input
                                type="checkbox"
                                checked={
                                  checkedAll[data[3] + '_' + subData[0]] || ''
                                }
                                onChange={(e) =>
                                  selectAll(e, data[3] + '_' + subData[0])
                                }
                              />
                            </span>
                            <span className="clear-left10">
                              <input
                                type="search"
                                className="cnslng-fu-chld-srch"
                                placeholder="Search here..."
                                value={
                                  childSerch[data[3] + '_' + subData[0]] || ''
                                }
                                onChange={(e) =>
                                  handleChildSerch(
                                    e,
                                    data[3] + '_' + subData[0],
                                  )
                                }
                              />
                              {subData[4] !== 'dx' && subData[4] !== 'focus' ? (
                                <Button
                                  variant="primary"
                                  onClick={() => setAddSubChild(true)}
                                  title="Add new values"
                                  style={{
                                    float: 'right',
                                    marginRight: '10px',
                                  }}
                                >
                                  +
                                </Button>
                              ) : (
                                ''
                              )}
                            </span>
                            {addSubChild && (
                              <AddSubValPopup
                                closeDialog={() => setAddSubChild(false)}
                                masCatId={data[3]}
                                masterId={subData[0]}
                                childId={''}
                                handleCalbackData={handleCalbackData}
                                catIndex={i}
                                subCatIndex={j}
                                formName="therapy"
                                heading={subData[1]}
                              />
                            )}
                            {editSubChild.status && (
                              <AddSubValPopup
                                closeDialog={() =>
                                  setEditSubChild({
                                    ...editSubChild,
                                    status: false,
                                  })
                                }
                                masCatId={data[3]}
                                masterId={subData[0]}
                                childId={editSubChild?.data[2]}
                                handleCalbackData={handleCalbackData}
                                catIndex={i}
                                subCatIndex={j}
                                formName="therapy"
                                heading={subData[1]}
                                cat={editSubChild?.data[3]}
                              />
                            )}
                          </div>
                          {(() => {
                            if (subData[4] === 'dx' && allData?.probArr) {
                              return (
                                <CounselingSecColSubChildUnRegister
                                  data={data}
                                  subData={subData}
                                  checkBoxData={checkBoxData}
                                  handleCheckBoxChange={handleCheckBoxChange}
                                  handleRemoveSubChild={handleRemoveSubChild}
                                  moduleName={'ptc'}
                                  allData={allData?.probArr}
                                  checkboxRef={checkboxRef}
                                  handleCheckBoxLable={handleCheckBoxLable}
                                />
                              );
                            } else if (
                              subData[4] === 'focus' &&
                              allData?.golObjData
                            ) {
                              return (
                                <CounselingSecColSubChildUnRegister
                                  data={data}
                                  subData={subData}
                                  checkBoxData={checkBoxData}
                                  handleCheckBoxChange={handleCheckBoxChange}
                                  handleRemoveSubChild={handleRemoveSubChild}
                                  moduleName={'ptc'}
                                  allData={allData?.golObjData}
                                  checkboxRef={checkboxRef}
                                  handleCheckBoxLable={handleCheckBoxLable}
                                />
                              );
                            } else if (
                              subData[4] === 'Medications' &&
                              allData?.activeMeds
                            ) {
                              return (
                                <CounselingSecColSubChildUnRegister
                                  data={data}
                                  subData={subData}
                                  checkBoxData={checkBoxData}
                                  handleCheckBoxChange={handleCheckBoxChange}
                                  handleRemoveSubChild={handleRemoveSubChild}
                                  moduleName={'ptc'}
                                  allData={allData?.activeMeds}
                                  checkboxRef={checkboxRef}
                                  handleCheckBoxLable={handleCheckBoxLable}
                                />
                              );
                            } else {
                              return (
                                <CounselingSecColSubChild
                                  data={data}
                                  subData={subData}
                                  checkBoxData={checkBoxData}
                                  handleCheckBoxChange={handleCheckBoxChange}
                                  handleRemoveSubChild={handleRemoveSubChild}
                                  handleEditSubChild={handleEditSubChild}
                                  moduleName={'ptc'}
                                  checkboxRef={checkboxRef}
                                  handleCheckBoxLable={handleCheckBoxLable}
                                  allData={allData}
								  editModeEnabled={true}
                                />
                              );
                            }
                          })()}
                        </div>
                      ))}
                  </div>
                ))}
              </div>
              <div className="mat-cnslng-col3">
                {allData?.therapyMasterData?.map((data, i) => (
                  <div key={i}>
                    {data[2]?.map((subData, j) => (
                      <div
                        key={j}
                        className={
                          i === 0 && j === 0
                            ? 'grid-sec cnslng-actv-area'
                            : 'grid-sec'
                        }
                        ref={(el) =>
                          (scrollRefs.current[
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          ] = el)
                        }
                      >
                        <span className="pop-up-sb-hdr">{subData[1]}</span>
                        {/* <div
                          className="cnslng-poup-txtrea"
                          placeholder="Write here..."
                          contentEditable={true}
                          onBlur={(e) => handleInputChange(e)}
                          //onInput={handleInputChange}
                          dangerouslySetInnerHTML={{
                            __html:
                              textAreaData[
                                'therapyDetailsText_' +
                                  data[3] +
                                  '_' +
                                  subData[0]
                              ],
                          }}
                          id={
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          }
                          name={
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          }
                          spellCheck="true"
                          // value={
                          //   textAreaData &&
                          //   textAreaData[
                          //     'therapyDetailsText_' + data[3] + '_' + subData[0]
                          //   ]
                          // }
                          // onChange={handleInputChange}
                        /> */}
                        <textarea
                          className="cnslng-poup-txtrea"
                          placeholder="Write here..."
                          id={
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          }
                          name={
                            'therapyDetailsText_' + data[3] + '_' + subData[0]
                          }
                          spellCheck="true"
                          value={
                            // Assuming 'textAreaData' is the state holding the cleaned data
                            textAreaData?.[
                              'therapyDetailsText_' + data[3] + '_' + subData[0]
                            ] || '' // Add fallback for a safer render
                          }
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {appGrpId && appGrpId === '0' && (
          <div className="gnrl-dtl-btn-rw">
            {(allData.mode === 'add' && (
              <Button variant="primary" onClick={handleCounsellingFormSave}>
                Save
              </Button>
            )) ||
              (allData.mode === 'update' && (
                <Button variant="primary" onClick={handleCounsellingFormUpdate}>
                  Update
                </Button>
              ))}

            <Button
              variant="default"
              onClick={handleCloseFun}
              style={{ marginRight: '10px' }}
            >
              Cancel
            </Button>
          </div>
        )}
        {removeSubChild && (
          <ConfirmDialog
            bodytext={'Do you want to remove it?'}
            closeDialog={() => setRemoveSubChild(false)}
            successDialog={handleRemoveSubChildConfirm}
            sucPrams={sucPrams}
          />
        )}
        {subTypePopup && (
          <SubTypePopup
            closeDialog={() => setSubTypePopup(false)}
            subChildPrams={subChildPrams}
            callBack={handlesubtypeform}
            form={'therapy'}
          />
        )}
      </div>
    </div>
  );
}

export default CounsellingPopup;
